"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function getDerivedState(props) {
    return {
        /**
         * Creates a map of the initial values for each field
         * Ex: {[field.path]: 'value'}
         */
        initialValues: props.fields.reduce((acc, field) => (Object.assign(Object.assign({}, acc), field.getInitialValue())), {}),
        /**
         * Creates a config object for each field and subField
         * Ex: {[field.path]: configs}
         */
        configs: props.fields.reduce((acc, field) => (Object.assign(Object.assign({}, acc), field.getConfig())), {}),
        /**
         * If provided, used to set the isReadOnly value on every field
         */
        isReadOnly: props.isReadOnly,
        /**
         * Combined errors messages, populated onSubmit. Errors are pulled
         * from both state.updatedFields and any required field with an empty value
         */
        allErrorsSet: new Set(),
        /**
         * Set to true onSubmit; and back to false by calling onSubmit callback
         */
        isSubmitting: false,
        /**
         * List of field configs
         */
        fields: props.fields,
        /**
         * Optional onChange prop provided by consumer. Arguments are:
         * onChange({ updatedFields<Object>, isValid<Boolean> })
         */
        onChange: props.onChange,
        /**
         * If provided, fields will be initially set using
         * value and/or error in this object.
         * Ex: { [path]: { value, errors } }
         */
        updatedFields: props.updatedFields || {},
        /**
         * A Boolean that tells us whether the form is valid
         * (meaning has no validation or requiredness errors)
         */
        isValid: false,
        /**
         * Overrides the screen size fields switch to mobile view
         */
        breakpoints: props.breakpoints || {},
        /**
         * When a custom isRequiredMarker string is passed into the
         * top-level of the form config, it overrides the default ' *'
         */
        isRequiredMarker: props.isRequiredMarker !== undefined ? props.isRequiredMarker : ' *',
        /**
         * When a custom isNotRequiredMarker string is passed into the
         * top-level of the form config, it overrides the default ''
         */
        isNotRequiredMarker: props.isNotRequiredMarker !== undefined ? props.isNotRequiredMarker : null
    };
}
exports.default = getDerivedState;
//# sourceMappingURL=get-derived-state.js.map